import { CLICK, componentWithVariants, demoFile, story, variant } from 'system/demo';
import { t } from 'util/stdtypes';

import { AutoModeratorReactionTypesWidget } from '../autoModeratorReactions';

const prompt = { key: 'p1', suggestedPerspective: 'Be nice', reminder: 'Be kind', time: Date.now() };
const reactionTypes = [
    { label: t('Thank you'), emoji: '🙏' },
    { label: t('Disagree'), emoji: '🤔' },
];

demoFile('open-modules/zdf/component/conversationhelper/autoModeratorReactions');

const baseState = {
    collections: {
        thought_provoking_prompt: [prompt],
    },
};

componentWithVariants(
    'AutoModeratorReactionTypesWidget',
    AutoModeratorReactionTypesWidget,
    {
        args: { thoughtProvokingPrompt: prompt },
        state: baseState,
        config: { conversationHelperReactionTypes: reactionTypes },
    },
    [
        variant('Add Reaction', {}, [story('Click', [CLICK('Thank you')])]),
        variant(
            'Remove Reaction',
            {
                state: {
                    collections: {
                        thought_provoking_prompt: [prompt],
                        thought_provoking_prompt_reactions: [{ key: 'r1', reactTo: 'p1', from: 'a', reactionType: 'Thank you' }],
                    },
                },
                config: { conversationHelperReactionTypes: reactionTypes },
            },
            [story('Undo', [CLICK('Thank you')])],
        ),
    ],
);
